import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import { AppType } from '../../App/reducer';
import Header from '../../../components/MenuManager/Header';
import RoutesUtils from '../../../utils/routes';
import { getHeaderMenuModes } from '../constants';
import DriveItemUtils from '../../../utils/driveItem';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: {
			config: galleryConfig,
			template: {
				sharedMethods,
			} = { sharedMethods: undefined },
		},
		menuManager, routerParamsHistory,
		authentication, appInfos, search, sharePanel, profile,
		backToPublication: {
			publicationId: lastPublicationId
		}
	} = state;

	const menuModes = getHeaderMenuModes(search, sharePanel, menuManager.menuModes);
	const { needCredentials } = authentication.userInfos;
	const { origin } = routerParamsHistory[routerParamsHistory.length - 1].params;
	const type = appInfos.type || AppType.Single;
	const isDownloadable = sharedMethods && sharedMethods.includes(Api.ShareMethod.Download);
	const isMultiApp = Utils.isMultiApp(appInfos);
	const isReadOnlyApp = Utils.isReadOnlyApp(profile.role);

	// Secured galleries can't share the root gallery
	const isSecure = Utils.isSecure(type, needCredentials);
	const isGalleryRoot = RoutesUtils.isGalleryRoot(routerParamsHistory);
	const isShareable = DriveItemUtils.isShareable(sharedMethods, galleryConfig) && !(isGalleryRoot && isSecure);
	const hasLastPublication = !!lastPublicationId;

	return {
		galleryConfig, menuModes, isShareable, isDownloadable,
		origin, isMultiApp, isReadOnlyApp, hasLastPublication
	};
};

export default connect(mapStateToProps)(Header);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/index.tsx